import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import Swiper, { Navigation, Pagination,  Scrollbar, Autoplay, FreeMode, EffectFade } from 'swiper';


function homepage() {
  //const numberslides = $("[data-element='slider_home'] .swiper-slide").length
  const widthpage = $(window).width();
  const sectionsize = widthpage;
  const bar = $('.swiper-pagination-progressbar-fill');
  const swiperhome = new Swiper("[data-element='slider_home']", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    allowTouchMove:false,
    speed: 800,
    effect: 'fade',
    loop: true,
				autoplay: {
				delay: 4000,
			},
   

    on: {
      init: function () {
        gsap.to(bar, {duration:4, ease: "none.none", width:sectionsize})
      },
     

      
    },
   
  });

  swiperhome.on('realIndexChange', function (e) {
    if( swiperhome.realIndex === 0) {
      gsap.set(bar, {width:0})
    }
    gsap.fromTo(bar, {width:0}, {delay:.8,duration:4, ease: "none.none", width:sectionsize})

});
   
}

export default homepage;

